// extracted by mini-css-extract-plugin
module.exports = {"component":"IsClassicNetwork_component__znsLN"};